import React from "react";
import { css } from "emotion";
import { messageStyle } from "./style";

const ErrorMessage = ({ children }) => {
	return (
		<div
			className={css`
				${messageStyle};
			`}
		>
			{children}
		</div>
	);
};

export default ErrorMessage;
